export const lang = {
  launchGame: {
    en: "Launch Game Successfully, if it doesnot display the game, please check that your browser allows pop-up windows to be displayed.",
    zh: "启动游戏成功，若无跳出游戏，请检查浏览器允许显示弹出视窗"
  }
}